import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seguimiento-inspeccion',
  templateUrl: './seguimiento-inspeccion.component.html',
  styleUrls: ['./seguimiento-inspeccion.component.css']
})
export class SeguimientoInspeccionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
